import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import { glossaryTerms } from "@/mocks/home";

export default function GlossaryTabs() {
  const [active, setActive] = useState(0);

  return (
    <section id="glossary" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <Reveal>
          <div className="max-w-2xl">
            <p className="font-label text-xs font-semibold uppercase tracking-[0.25em] text-primary-600">
              Glossary
            </p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              字幕与语言术语小词典
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              标题与标签里出现的这些词含义并不完全相同。点击下方词条，查看它们各自指向的内容与常见标注方式。
            </p>
          </div>
        </Reveal>

        <div className="mt-10 grid gap-8 lg:grid-cols-[0.85fr_1.15fr]">
          <Reveal>
            <div
              role="tablist"
              aria-label="字幕与语言术语"
              className="flex flex-col gap-2 rounded-lg border border-background-200 bg-background-50 p-3"
            >
              {glossaryTerms.map((term, index) => (
                <button
                  key={term.term}
                  type="button"
                  role="tab"
                  aria-selected={active === index}
                  onClick={() => setActive(index)}
                  className={`flex items-center justify-between gap-3 rounded-md px-4 py-3 text-left transition-colors ${
                    active === index
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
                  }`}
                >
                  <span className="flex items-center gap-3">
                    <span
                      className={`font-label text-xs ${
                        active === index ? "text-background-100" : "text-secondary-500"
                      }`}
                    >
                      0{index + 1}
                    </span>
                    <span className="text-sm font-semibold">{term.term}</span>
                  </span>
                  <i
                    className={`text-base ${active === index ? "ri-arrow-right-line" : "ri-arrow-right-up-line"}`}
                    aria-hidden="true"
                  ></i>
                </button>
              ))}
            </div>
          </Reveal>

          <Reveal delay={80}>
            <div className="relative overflow-hidden rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
              {glossaryTerms.map((term, index) => (
                <div key={term.term} role="tabpanel" hidden={active !== index}>
                  <div className="flex items-center gap-3">
                    <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                      <i className="ri-book-marked-line text-lg" aria-hidden="true"></i>
                    </span>
                    <div>
                      <h3 className="font-heading text-xl font-bold text-foreground-950">{term.term}</h3>
                      <p className="font-label text-xs text-secondary-600">简称 · {term.short}</p>
                    </div>
                  </div>
                  <p className="mt-5 text-sm font-medium leading-relaxed text-foreground-800 md:text-base">
                    {term.definition}
                  </p>
                  <p className="mt-4 text-sm leading-relaxed text-foreground-600">{term.detail}</p>
                  <p className="mt-6 flex items-start gap-2 rounded-md bg-secondary-100 px-4 py-3 text-xs text-secondary-900">
                    <i className="ri-price-tag-3-line mt-0.5" aria-hidden="true"></i>
                    <span>{term.example}</span>
                  </p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}